import React from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  Link
} from "react-router-dom";


function onMenuIconClick() {
  var menuIcon = document.querySelector('nav ul');

  if (menuIcon != null) {
    menuIcon.classList.toggle("showing");
  }
}

export const Header = (props) => (
  <header>
    <nav>
      <div onClick={onMenuIconClick} className="menu-icon">
        <FontAwesomeIcon icon="bars" />
      </div>
      <div className="App__logo"><Link to="/">Riselio</Link></div>
      <div className="menu">
        <ul className="white">
          <li><Link to="/cara-pakai">Cara Pakai</Link></li>
          <li><Link to="/faq">FAQ</Link></li>
          <li><Link to="/daftar-supplier">Menjadi Supplier</Link></li>
          <li><Link to="/ebook-vip">VIP</Link></li>
        </ul>
      </div>
    </nav>
  </header>
)